import { render, staticRenderFns } from "./MariaHeaderDispatchPanel.vue?vue&type=template&id=32acc240"
import script from "./MariaHeaderDispatchPanel.vue?vue&type=script&lang=js"
export * from "./MariaHeaderDispatchPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports